// extracted by mini-css-extract-plugin
export default {"switch":"ViewPropertyStyle_switch__VYlxq","slider":"ViewPropertyStyle_slider__Riu2P","round":"ViewPropertyStyle_round__OTFzB"};